import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom'
import store from './store';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';


import AnimatedRoutes from 'Routes';


function App() {
  
  return (
    <HelmetProvider>
      {/* Este Helmet ahora solo establece REGLAS para todo el sitio.
        1. titleTemplate: Aplica un formato a todos los títulos de las páginas hijas. 
           "%s" será reemplazado por el título que definas en cada página.
        2. defaultTitle: El título que se usará si una página no tiene su propio <title>.
      */}
      <Helmet 
         
        defaultTitle="Linar | Inspecciones de Izaje y maquinaria vial"
      />

      <Provider store={store}>
        <Router>
          <AnimatedRoutes />
        </Router>
      </Provider>
    </HelmetProvider>
  );

}

export default App;
